
import Vue from 'vue';
import 'jquery-validation';

Vue.component('userlogin-vue', {
  methods: {
    showPassword(ele) {
      const passwordField = ele.previousElementSibling;
      passwordField && passwordField.setAttribute('type', 'text');
    },

    hidePassword(ele) {
      const passwordField = ele.previousElementSibling;
      passwordField && passwordField.setAttribute('type', 'password');
    },
  },
  mounted() {
    const submitButton = this.$el.querySelector('#edit-submit');
    if(submitButton){
      submitButton.addEventListener('click', () => {
        const form = $('#user-login-form');

        form.validate({
          errorClass: 'js-error',
          // Validation rules and messages for each field
          rules: {
            name: {
              required: true,
              email: true,
            },
            pass: 'required',
          },
          pass: {
            username: {
              required: 'Please enter your email',
              email: 'Please enter a valid email address',
            },
            pass: 'Please enter your password',
          },
        });

        if (form.valid()) {
          form.submit();
        }
      });
    }
  },
});
